import { useTranslation } from 'react-i18next'
import CategoryCard from './CategoryCard'
import { SectionWrapper, SectionTitle, CardGrid } from './styled-components'

const CategoryCardGrid = ({ categories }) => {
  const { t } = useTranslation('gamification')

  return (
    <SectionWrapper>
      <SectionTitle>{t('salesGoalsTitle')}</SectionTitle>
      <CardGrid>
        {categories.map(category => (
          <CategoryCard key={category.id} category={category} />
        ))}
      </CardGrid>
    </SectionWrapper>
  )
}

export default CategoryCardGrid
